/**
 * @fileoverview App component.core
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';
// Library Import
import '../../lib/mobiscroll/themes/windows';
import '../../lib/mobiscroll/themes/auto-theme';
import '../../lib/mobiscroll/i18n/ja';
import _ from 'lodash';
// Util Import
import * as LogUtil from '../../util/LogUtil';
import * as ConstUtil from '../../util/ConstUtil';

/**
 * グローバルエラーを捕捉
 *
 * @name window.onerror
 * @function
 * @param {String} message メッセージ
 * @param {String} source ソース
 * @param {String} line 行
 * @param {String} column 列
 * @param {Object} error エラーオブジェクト
 */
window.onerror = (message, source, line, column, error) => {
  LogUtil.e(
    'message:' +
      message +
      ' source:' +
      source +
      ' line:' +
      line +
      ' column:' +
      column +
      ' stack:' +
      error.stack
  );
};

/**
 * postMessageイベント登録
 *
 * @name window.onerror
 * @function
 * @param {Object} event イベント
 */
// window.addEventListener(
//   'message',
//   function(event) {
//     if (_.isEmpty(event)) {
//       return;
//     }
//     if (_.isEmpty(event.data)) {
//       return;
//     }
//     // ポータルからの情報をセット
//     localStorage.setItem(
//       ConstUtil.Common.STORAGE_KEY.ACCOUNT_ID,
//       event.data.id
//     );
//     localStorage.setItem(
//       ConstUtil.Common.STORAGE_KEY.CENTER_INFO,
//       JSON.stringify(event.data.centerInfo)
//     );
//     localStorage.setItem(
//       ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID,
//       event.data.authorityId
//     );
//     localStorage.setItem(
//       ConstUtil.Common.STORAGE_KEY.TO_SCREEN_NO,
//       event.data.toScreenNo
//     );
//     localStorage.setItem(ConstUtil.Common.STORAGE_KEY.TOKEN, event.data.token);
//     // 送信元にpostMessage
//     event.source.postMessage(event.data.centerInfo.domain, event.origin);
//   },
//   false
// );

/**
 * App
 *
 * @class App
 * @extends {Component}
 */
class App extends Component {
  constructor(props) {
    super(props);
    LogUtil.d('App Class constructor call');
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof App
   */
  render() {
    return (
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/js/component/core/App.jsx